export default __webpack_public_path__ + "media/images/59-55550b7dbabbe2d5a332841b8651d766.jpg";